/* eslint-disable @typescript-eslint/no-explicit-any */

import React from 'react';
import { Typography } from 'antd';
import { FormikValues } from 'formik';
import { useIntl } from '../../../common/config/i18n';

const { Paragraph } = Typography;

type Props = {
  formik?: FormikValues;
  fieldName?: string;
  message?: string;
  centered?: boolean;
};

const FormError = ({ formik, fieldName, message = '', centered }: Props) => {
  const { t } = useIntl();
  const resolveCondition = () => {
    if (message !== '') {
      return true;
    }
    if (formik && fieldName) {
      if (formik.errors[fieldName]?.message && formik.errors[fieldName]?.path) {
        let touched: any = formik.touched[formik.errors[fieldName].path?.[0]];
        const touchedChifted = formik.errors[fieldName].path?.slice(1);
        touchedChifted?.forEach((key: string | number) => {
          if (typeof key === 'number') {
            const elemFinded = touched?.find((_item: any, index: number) => index === key);
            touched = { ...elemFinded };
          } else {
            touched = touched[key];
          }
        });
        return formik.errors[fieldName].message && touched;
      } else {
        return formik.errors[fieldName] && formik.touched[fieldName];
      }
    }
    return false;
  };

  return (
    <div className="FormError">
      {resolveCondition() && (
        <Paragraph type="danger" style={centered ? { textAlign: 'center' } : undefined}>
          {formik && fieldName
            ? formik.errors[fieldName]?.message
              ? t('formErrors', formik.errors[fieldName].message)
              : t('formErrors', formik.errors[fieldName])
            : message}
        </Paragraph>
      )}
    </div>
  );
};

export default FormError;
